export const SIGN_IN_SUCCESS_MSG = "You are logged in!";